import { PassportUpdateInfoPopup } from '~/src/features/lk/PassportUpdate/containers/PassportUpdateInfoPopup';
import { PassportUpdateResultPopup } from '~/src/features/lk/PassportUpdate/containers/PassportUpdateResultPopup';
import { useUpdatePassportData } from '~/src/features/lk/PassportUpdate/hooks/useUpdatePassportData';

import { usePassportUpdate } from './usePassportUpdate';

// Алерт о необходимости актуализации паспортных данных
export { PassportUpdateAlert } from '~/src/features/lk/PassportUpdate/containers/PassportUpdateAlert';

/**
 * Актуализация паспортных данных
 */
export const PassportUpdate = () => {
    const passportUpdate = usePassportUpdate();

    useUpdatePassportData(passportUpdate);

    if (!passportUpdate) {
        return null;
    }

    return (
        <>
            <PassportUpdateInfoPopup/>
            <PassportUpdateResultPopup/>
        </>
    );
};
